var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vender"}},[_c('new-article'),_c('loading-afip-ticket'),_c('articles-loading-advise'),_c('current-acounts'),_c('select-payment-methods'),_c('payment-methods-with-discounts'),_c('nav-component'),_c('client'),_c('remito')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }